// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rj-c";
export var backButton = "_rj-4";
export var backIcon = "_rj-5";
export var chevronShortcut = "_rj-6";
export var container = "_rj-1";
export var editor = "_rj-8";
export var editorWrapper = "_rj-7";
export var prefix = "_rj-2";
export var searchIcon = "_rj-3";
export var suffix = "_rj-9";
export var suffixContent = "_rj-a";
export var suffixText = "_rj-b";
export var wrapper = "_rj-0";